export default "__VITE_ASSET__DCGYTcOH__"